export default "__VITE_ASSET__C$CLPMQy__"